export default __webpack_public_path__ + "static/media/news-04.ae00f8ea.jpg";